module.exports = __webpack_public_path__ + "static/media/music-note.c4cf8709.svg";